import { motion, useScroll, useTransform } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';

const LOGO_AVIF = 'https://customer-assets.emergentagent.com/job_3ec12bb3-915e-4bbb-87b2-e085aa4a2c01/artifacts/jfotexpw_Logo%20Wee%20V2%20-%202026%20-%20SBG.HQ.avif';
const LOGO_WEBP = 'https://customer-assets.emergentagent.com/job_3ec12bb3-915e-4bbb-87b2-e085aa4a2c01/artifacts/76ox2huh_Logo%20Wee%20V2%20-%202026%20-%20SBG.HQ.webp';

export default function LeftPane() {
  const { t } = useLanguage();
  const { scrollYProgress } = useScroll();
  const ringRotation = useTransform(scrollYProgress, [0, 1], [0, 360]);

  return (
    <div
      data-testid="left-pane"
      className="hidden md:flex fixed left-0 top-0 w-1/2 h-screen items-center justify-center bg-[#F9F8F6] z-10"
    >
      <svg
        className="absolute w-[600px] h-[600px] opacity-[0.03]"
        viewBox="0 0 600 600"
      >
        <ellipse cx="300" cy="300" rx="280" ry="260" fill="#C2A8F7" />
      </svg>

      <div className="relative w-[85%] max-w-[700px] aspect-square">
        <picture>
          <source srcSet={LOGO_AVIF} type="image/avif" />
          <source srcSet={LOGO_WEBP} type="image/webp" />
          <img
            src={LOGO_WEBP}
            alt={t.slogan.logoAlt}
            fetchPriority="high"
            loading="eager"
            decoding="async"
            width={1200}
            height={1200}
            data-testid="logo-large"
            className="w-full h-full object-contain relative z-10"
          />
        </picture>

        <motion.div
          className="absolute inset-[-8%] rounded-full border border-[#35589B]/[0.07] z-0"
          style={{ rotate: ringRotation }}
        >
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-[#35589B]/20" />
        </motion.div>
      </div>
    </div>
  );
}
